  function bindCityAutocomplete(input) {
    if (!input || input.dataset.pjPlacesBound === 'true' || typeof google === 'undefined' || !google.maps || !google.maps.places) {
      return;
    }

    input.dataset.pjPlacesBound = 'true';

    var autocomplete = new google.maps.places.Autocomplete(input, {
      types: ['(cities)'],
    });

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      var city = '';
      var region = '';
      var country = '';

      if (place && place.address_components) {
        for (const component of place.address_components) {
          if (
            !city &&
            (component.types.includes('locality') ||
              component.types.includes('postal_town') ||
              component.types.includes('administrative_area_level_2'))
          ) {
            city = component.long_name;
          }
          if (component.types.includes('administrative_area_level_1')) {
            region = component.long_name;
          }
          if (component.types.includes('country')) {
            country = component.long_name;
          }
        }
      }

      var formatted =
        (place && place.formatted_address) || [city, region, country].filter(Boolean).join(', ');
      if (formatted) {
        input.value = formatted;
      }

      input.dispatchEvent(
        new CustomEvent('pj-city-selected', {
          bubbles: true,
          detail: { city: input.value },
        })
      );
    });
  }

  function initializeAutocomplete() {
    bindCityAutocomplete(document.getElementById('AddressZipNew'));
    bindCityAutocomplete(document.getElementById('pj_guest_city'));
    bindCityAutocomplete(document.getElementById('pj_env_modal_city'));
  }

  if (window.google && google.maps && google.maps.event) {
    google.maps.event.addDomListener(window, 'load', initializeAutocomplete);
  } else {
    window.addEventListener('load', initializeAutocomplete);
  }
